export default __webpack_public_path__ + "static/media/eth.3e39c80d.svg";